"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BorrowerType = void 0;
/**
 * Consumer loan borrower type.  This is different from the AppsDb.BOrrowerType which applies to
 * all other loan types.
 */
var BorrowerType;
(function (BorrowerType) {
    BorrowerType["PRIMARY"] = "PRIMARY";
    BorrowerType["COBORROWER"] = "CO-BORROWER";
    BorrowerType["RELATIVE"] = "RELATIVE";
})(BorrowerType = exports.BorrowerType || (exports.BorrowerType = {}));
